import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SwPush } from '@angular/service-worker';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit {
  title = 'multikart-backend';

  constructor(
    private swPush: SwPush,
    private router: Router,
  ){}

  ngOnInit(): void {
    this.swPush.notificationClicks.subscribe(event => {
      const url = event.notification.data?.url;
      if (url) {
        this.router.navigateByUrl(url);
      }
    });
  }
}
